import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

import {
  IconPlaylist,
  Image as EncoreImage,
} from '@spotify-internal/encore-creator-web';
import { gray90, gray60 } from '@spotify-internal/encore-foundation';

const Container = styled.div`
  position: relative;
  width: ${props => `${props.size}px`};
  min-width: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};
  margin: ${props => (props.stacked ? '0 auto' : null)};
`;

const DisplayWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  opacity: ${props => (props.show ? 1 : 0)};
  transition: opacity 300ms ease;

  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => (props.transparent ? 'transparent' : gray90)};
  color: ${gray60};
`;

export class CoverArt extends Component {
  static propTypes = {
    className: PropTypes.string,
    imgSrc: PropTypes.string,
    size: PropTypes.oneOf([16, 24, 32, 48, 64, 96, 144]),
    stacked: PropTypes.bool,
    defaultIcon: PropTypes.node,
  };

  static defaultProps = {
    size: 64,
    defaultIcon: <IconPlaylist iconSize={24} data-testid="playlist-icon" />,
  };

  state = {
    hasValidImageURI: false,
  };

  isComponentDestroyed = false;

  componentDidMount() {
    if (this.props.imgSrc) {
      this.checkImageURI(this.props.imgSrc);
    }
  }

  componentWillUnmount() {
    this.isComponentDestroyed = true;
  }

  checkImageURI = imgSrc => {
    if (!imgSrc) return;

    const img = new Image();
    img.onload = () => {
      if (!this.isComponentDestroyed) {
        this.setState({ hasValidImageURI: true });
      }
    };
    img.onerror = () => {
      if (!this.isComponentDestroyed) {
        this.setState({ hasValidImageURI: false });
      }
    };
    img.src = imgSrc;
  };

  render() {
    const { className, imgSrc, size, stacked, defaultIcon } = this.props;
    return (
      <Container
        data-testid="cover-art"
        className={className}
        size={size}
        stacked={stacked}
      >
        <DisplayWrapper show>{defaultIcon}</DisplayWrapper>
        <DisplayWrapper show={this.state.hasValidImageURI} transparent>
          <EncoreImage
            placeholderSrc="data:image/png;base64,R0lGODlhFAAUAIAAAP///wAAACH5BAEAAAAALAAAAAAUABQAAAIRhI+py+0Po5y02ouz3rz7rxUAOw=="
            width={size}
            height={size}
            src={imgSrc}
            importance="low"
            crop
          />
        </DisplayWrapper>
      </Container>
    );
  }
}
